import { Get, Post } from "services";
import { ApiPath } from "paths";
// import instanceMockApi from "services/api-mock.service";

export const searchDevice = async (body) => {
  const res = await Post(`${ApiPath.SEARCH_DEVICE}`, body);
  return res;
};

export const searchDeviceWithTransaction = async ({ venueId, ...body }) => {
  const res = await Post(`${ApiPath.DEVICE_WITH_TRANSACTION(venueId)}`, body);
  return res;
};

export const getDevice = async ({ deviceId }) => {
  const res = await Get(`${ApiPath.DEVICE_ID(deviceId)}`);
  return res.data;
};

export const editDevice = async ({ deviceId, deviceName }) => {
  const res = await Post(`${ApiPath.DEVICE_ID(deviceId)}`, { deviceName });
  return res;
};

// export const getDeviceTracking = async ({ venueId }) => {
//   const res = await instanceMockApi.Get(`${ApiPath.DEVICE_TRACKING}`, { venueId });
//   return res;
// };

export const getLastVersion = async ({ venueId }) => {
  const res = await Get(`inventory/app-version`, { venueId });
  return res;
};
